import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=5e4359ad&scoped=true&"
import script from "./HomeProducts.vue?vue&type=script&lang=js&"
export * from "./HomeProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&id=5e4359ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4359ad",
  null
  
)

export default component.exports